import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import logo from '../data/ziyara.png';

const contactEmail = 'contact@ziyara.dz';
/** Affichage + lien tel: (adapter les numéros réels) */
const contactPhoneDisplay = '+213 555 00 00 00';
const contactPhoneTel = '+213555000000';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-800 bg-gray-950 text-white">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          {/* Marque */}
          <div className="lg:col-span-4">
            <Link to="/home" className="inline-flex items-center gap-2">
              <img src={logo} alt="Ziyara" className="h-12 w-auto" />
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-gray-400">
              Marketplace voyage : comparez les séjours proposés par des agences partenaires en
              Algérie et réservez en toute confiance.
            </p>
          </div>

          {/* Liens utiles */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white">
              Liens utiles
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/home"
                  className="text-gray-400 transition hover:text-white"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  to="/offres"
                  className="text-gray-400 transition hover:text-white"
                >
                  Tous les séjours
                </Link>
              </li>
              <li>
                <Link
                  to="/home#destinations"
                  className="text-gray-400 transition hover:text-white"
                >
                  Destinations populaires
                </Link>
              </li>
              <li>
                <Link
                  to="/home#packages"
                  className="text-gray-400 transition hover:text-white"
                >
                  Séjours à la une
                </Link>
              </li>
              <li>
                <Link
                  to="/agences"
                  className="text-gray-400 transition hover:text-white"
                >
                  Nos agences partenaires
                </Link>
              </li>
              <li>
                <Link
                  to="/waitlist"
                  className="text-gray-400 transition hover:text-white"
                >
                  Liste d’attente agences
                </Link>
              </li>
            </ul>
          </div>

          {/* Espace agences */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white">
              Agences
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link
                  to="/login"
                  className="text-gray-400 transition hover:text-white"
                >
                  Connexion agence
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white">
              Contact
            </h3>
            <ul className="mt-4 space-y-4 text-sm text-gray-400">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-blue-500" aria-hidden />
                <span>Réseau d&apos;agences en Algérie</span>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-blue-500" aria-hidden />
                <a href={`tel:${contactPhoneTel}`} className="transition hover:text-white">
                  {contactPhoneDisplay}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-blue-500" aria-hidden />
                <a href={`mailto:${contactEmail}`} className="transition hover:text-white">
                  {contactEmail}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Légal + copyright */}
        <div className="mt-12 flex flex-col gap-4 border-t border-gray-800 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-center text-xs text-gray-500 md:text-left">
            © {currentYear} Ziyara. Tous droits réservés.
          </p>
          <nav
            aria-label="Informations légales"
            className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-500"
          >
            <a
              href={`mailto:${contactEmail}?subject=Mentions%20légales`}
              className="transition hover:text-gray-300"
            >
              Mentions légales
            </a>
            <a
              href={`mailto:${contactEmail}?subject=Politique%20de%20confidentialit%C3%A9`}
              className="transition hover:text-gray-300"
            >
              Confidentialité
            </a>
            <a
              href={`mailto:${contactEmail}?subject=Conditions%20g%C3%A9n%C3%A9rales%20d%27utilisation`}
              className="transition hover:text-gray-300"
            >
              CGU
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
